import '../styles/index.scss';


import { getSiteIdentifier } from './network/util.js';

import Application from './app.js';


let app;

document.addEventListener("DOMContentLoaded", function() {

	app = new Application();
	app.init();
});





